import { Button, Dialog, DialogContent, Divider, Grid, Paper, TextField, Toolbar, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import ClearIcon from "@material-ui/icons/Clear";
import MandatorySpan from "../sasl/models/MandatorySpan";
import { ChevronRight } from '@material-ui/icons';
import axios from 'axios';
import { smlUrl } from '../../../../../utils/config';
import jwtDecode from 'jwt-decode';
import { DESTROY_BACKDROP, OPEN_BACKDROP } from '../../../containers/actions/types';
import { useDispatch } from 'react-redux';
import BackDropLoading from '../models/BackDrop';

const ElectronicSignatureValidation = (props) => {
  const { open, onClose, classes, documentDetails, handleESignatureSuccess } = props;
  const dispatch = useDispatch();
    
    const tokenData = jwtDecode(localStorage.getItem('authToken'));

    const [teamMemberId, setTeamMemberId] = useState('');
    const [password, setPassword] = useState('');

    const [errors, setErrors] = useState({ error: false, userID:'', password:''})

    const handleVerifyUser = () => {

        if (teamMemberId === '' && password === '') {
            setErrors({...errors,userID:'Please enter Team member ID',password:'Please enter password'})
        } else if (teamMemberId === '') {
            setErrors({...errors,userID:'Please enter Team member ID'})
        } else if (password === '') {
            setErrors({...errors,password:'Please enter password'})
        } else if (teamMemberId !== "" && teamMemberId !== tokenData.email_address) {
            setErrors({...errors,userID:'Please enter valid Team member ID'})
        } else {
          
          const signInData = {
            email: teamMemberId,
            password: password,
          };
          dispatch({
            type: OPEN_BACKDROP,
          });
        axios
        .post(`${smlUrl}/user/verifySignUserLogin`, signInData)
        .then((res) => {
          if (res.data.status === true) {
            handleESignatureSuccess('electronicSignSuccess')
            dispatch({
              type: DESTROY_BACKDROP,
            });
          } else {
            dispatch({
              type: DESTROY_BACKDROP,
            });
            setErrors({...errors, error: true, password:'Please enter valid password'})
          }
          // else if (res.data.status === true && res.data.)
        })
        .catch((err) => {
          //console.log('login err', err);
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setErrors({...errors, error: true})
        });
        }
        
    }

  return (
    <Dialog
          open={open}
          onClose={onClose} fullWidth maxWidth="lg"
          disableBackdropClick // Disable closing on outside click
          disableEscapeKeyDown // Disable closing on escape key
    >
      <BackDropLoading />
      <Paper style={{ padding: '1.5rem' }}>
      <Toolbar className={classes.header}>
          <Typography style={{fontWeight:500, fontSize:'2rem'}} className={classes.flexGrow}>
            Complete electronic signature
              </Typography>
              <div className={classes.closeText}
              onClick={onClose}
              >
          <Typography
            variant="body2"
            style={{ fontWeight:500,cursor: "pointer" }}
            
          >
            Cancel 
              </Typography>
                <ClearIcon style={{color:'#FF0000'}} />
                </div>
        </Toolbar>
        {errors.error && (
        <Grid container item alignItems="center" justifyContent="center">
          <div
            style={{
              display: "flex",
              justifyContent: "center", // Horizontally center the CircularProgress
              alignItems: "center", // Vertically center the CircularProgress
              height: "50px", // Optional: Set a height to vertically center the loader
              border: "2px solid #FF0000",
              backgroundColor: "#FFF0F0",
              width: "50%",
            }}
          >
          <Typography style={{ textAlign: "center" }}>
          Something went wrong. Please try again.
          </Typography>
          </div>
        </Grid>
      )}
        
        <DialogContent>
              <Typography variant="h6" style={{ fontSize:'1.5rem', fontWeight: 500 }}>Declaration</Typography>
              <hr className={classes.hrLine} />
          <Typography style={{ margin: '1rem 0' }}>
            I, {tokenData.full_name}, am {documentDetails.qaDecision==='Approved' ?'approving':'rejecting'} the document '{documentDetails.fileName ? documentDetails.fileName:'NA'}'.
          </Typography>
          <Divider style={{ backgroundColor:'gray', margin: '2rem 0' }} />

              <Typography variant="h6" style={{ fontSize:'1.5rem',fontWeight: 500 }}>Electronic Signature</Typography>
              <hr className={classes.hrLine} />
          <Grid container>
            <Grid item xs={6} >
              <Typography style={{ fontWeight: 500 }} >Name</Typography>
              <Typography >{tokenData.full_name}</Typography>
            </Grid>
            <Grid xs={6}>
              <Typography style={{ fontWeight: 500 }} >Department-role</Typography>
              <Typography >{tokenData.role_name}</Typography>
            </Grid>
          </Grid>
          <Divider style={{ backgroundColor:'gray', margin: '2rem 0' }} />

              <Typography variant="h6" style={{ fontSize:'1.5rem', fontWeight: 500 }}>Confirm Signature</Typography>
              <hr className={classes.hrLine} />
              <Grid container spacing={2} alignItems="flex-end" >
                <Grid item xs={3}>
                <Typography style={{fontWeight: 500, marginBottom:'5px'}}>
                Team member ID<MandatorySpan/>
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
                    required
                    className={classes.textFieldSty}
                    placeholder="Team member ID"
                    value={teamMemberId}
                              onChange={(e) => {
                                  setErrors({ userID:'', password:''})
                                  setTeamMemberId(e.target.value)
                              }}
                              error={!!errors.userID}
              helperText={errors.userID}
        />
      </Grid>
                <Grid item xs={3}>
                <Typography style={{fontWeight: 500, marginBottom:'5px'}}>
                Password<MandatorySpan/>
        </Typography>
        <TextField
          fullWidth
          type="password"
                    variant="outlined"
                    className={classes.textFieldSty}
                    required
                    placeholder="Password"
                    value={password}
                              onChange={(e) => {
                                  setErrors({ userID: '', password: '' })
                                  setPassword(e.target.value)
                              }}
                              error={!!errors.password}
              helperText={errors.password}
        />
      </Grid>
      <Grid item xs={2}>
        {/* <Button
          variant="contained"
          color="secondary"
          fullWidth
          style={{ height: '100%', backgroundColor: '#f66a27', color: 'white', textTransform: 'none' }}
        >
          Confirm
        </Button> */}
                   <Button
          variant="contained"
          color="primary"
          endIcon={<ChevronRight />}
                              style={{ borderRadius: "20px", textTransform: "none" }}
                              onClick={()=>handleVerifyUser()}
        >
          Confirm
        </Button>
      </Grid>
    </Grid>
        </DialogContent>
      </Paper>
        </Dialog>
  )
}

export default ElectronicSignatureValidation